
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register/[slug]",
      function () {
        return require("private-next-pages/register/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/register/[slug]"])
      });
    }
  